import { FirearmStorageLocationPLIService } from '../model/firearm-storage-location-pli.service';
import { CrudDataSource, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { FirearmStorageLocationPLI } from 'assets-model';
import { Observable } from 'rxjs';


export class FirearmStorageLocationPLIDataSource extends CrudDataSource<FirearmStorageLocationPLI> {

  constructor(private service: FirearmStorageLocationPLIService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<FirearmStorageLocationPLI>> {
    return this.service.findByFullFilters(serviceArguments, pageSpec);
  }

}


